<script>
  import {
    VTabItem
  } from 'vuetify/lib'
  export default {
    name: 'wh-tab-item',
    extends: VTabItem
  };
</script>